import { ErrorHandler, Injectable } from '@angular/core';

/** What each browser says when a lazily loaded file is not there any more. */
const STALE_BUILD = /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|ChunkLoadError/i;

const RELOADED_AT = 'stale_build_reloaded_at';

/**
 * A page left open across a deploy still asks for the previous build's files
 * by their old names, and the server answers with index.html, so the next
 * screen or plugin it loads fails ("Failed to fetch dynamically imported
 * module"). Reloading picks up the new build. Done at most once a minute, so
 * a genuinely missing file cannot turn into a reload loop.
 */
@Injectable()
export class StaleBuildErrorHandler extends ErrorHandler {
    override handleError(error: any): void {
        const message = String(error?.message ?? error?.rejection?.message ?? error ?? '');

        if (STALE_BUILD.test(message) && this.mayReload()) {
            location.reload();
            return;
        }

        super.handleError(error);
    }

    private mayReload(): boolean {
        try {
            const last = Number(sessionStorage.getItem(RELOADED_AT) || 0);
            if (Date.now() - last < 60_000) return false;
            sessionStorage.setItem(RELOADED_AT, String(Date.now()));
            return true;
        } catch {
            return false;
        }
    }
}
